module.exports = __webpack_public_path__ + "static/media/fsc2.e66d7472.svg";